import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import CustomerMultiInput from 'legacy-modules/master/customer/components/customer-multi-input';
import GuestMultiInput from 'legacy-modules/master/guest/components/guest-multi-input';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  name?: string;
}

export default function ProjectDetail(props: Props) {
  const { t } = useTranslation();
  const { name = 'approvalable' } = props;
  const { navigate } = useNavigation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">
          {t('common:detail_extra', {
            extra: t('common:project'),
          })}
        </Text>
        <HOCInput keys={[name]}>
          {(value) => (
            <Button
              buttonType="secondary"
              onClick={() =>
                navigate(NavigationRoutes.ProjectView, {
                  id: value[name].id,
                })
              }
            >
              {t('common:view_old_data')}
            </Button>
          )}
        </HOCInput>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`${name}.name`}
            label={t('common:project')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input type="text" name={`${name}.code`} label={t('common:code')} />
        </HalfContainer>
      </SectionContainer>
      <FullContainer>
        <Input
          type="text"
          name={`${name}.description`}
          label={t('common:description')}
        />
      </FullContainer>
      <FullContainer>
        <CustomerMultiInput name={`${name}.projectCustomers`} required />
      </FullContainer>
      <FullContainer>
        <GuestMultiInput name={`${name}.projectGuests`} type="guest" required />
      </FullContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
